import apiClient from "./apiClient";

export async function loginRequest(payload) {
  return apiClient.post("/login", payload);
}

export async function logoutRequest() {
  return apiClient.post("/logout");
}

export function getProfileRequest() {
  return apiClient.get("/profile");
}
